import React, { useEffect } from "react";
import { connect } from "react-redux";

import { FaClock } from "react-icons/fa";



const PendingApprovalsTable = (props) => {

const {leaveType, fromDate, toDate, days, reason} = props;

return (
	<div>
    <span
      className={`absolute items-center right-5 text-xs rounded-full border status-indicator ${leaveType.toLowerCase().replace(" ", "-")}`}
      > 
        {leaveType}
    </span>
    <div className="m-3">Type </div>

    <div className="flex justify-between items-center bg-gray-50 rounded-xl mt-2 p-1 text-sm text-gray-700">
      <div className="flex-1 text-center">
        <p className="text-xs text-gray-500">FROM</p>
        <p className="font-semibold text-gray-900">{fromDate}</p>
      </div>
      <div className="flex-1 text-center border-l border-gray-200">
        <p className="text-xs text-gray-500">TO</p>
        <p className="font-semibold text-gray-900">{toDate}</p>
      </div>
    </div>

    <div className="flex justify-between items-center mt-2">
      <div className="flex items-center text-gray-500 text-sm">
        <FaClock className="mr-2 text-gray-500" />
        {days} days
      </div>
    </div>
      <div className="flex bg-gray-50 rounded-xl p-2 text-sm text-gray-700 mt-1">
      <div className="flex-1">
        <p className="text-xs text-gray-500">REASON</p>
        <p className="text-gray-900">{reason}</p>
      </div>
    </div>
   </div>
  );
};

const mapStateToProps = (state) => ({
	// recordList: state.trainingClass.trainingClassList?.items,
	// pagination: state.trainingClass.trainingClassList?.pagination,
	// filters: state.trainingClass.trainingClassList?.filters,
	// requesting: state.trainingClass.trainingClassList?.requesting,
	// error: state.trainingClass.trainingClassList?.error,
});

const mapDispatchToProps = (dispatch) => ({
	// doSearch: (filters) => dispatch(getTrainingClassList(filters)),
	// doDelete: (id) => dispatch(doTrainingClassDelete(id)),
	// doRecordReset: () => dispatch(doTrainingClassReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PendingApprovalsTable);
